import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { StatusEnum } from "@whatslly/types/tuvis-messaging/TuvisMessagingEnums";
import { getWabaErrorMessage } from "@whatslly/commons/tuvis-messaging/wabaErrors";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";
import { Tooltip } from "@whatslly/ui-components/Tooltip";
import styles from "./MessageAckFailed.module.scss";
import classNames from "classnames";

export const MessageAckFailed: React.FC<{
  status: string;
  errorCode?: number;
  reSendMessage: () => void;
  isResending?: boolean;
  hideResend?: boolean;
}> = ({ status, errorCode, reSendMessage, isResending, hideResend }) => {
  const { t } = useTranslation();

  const failureTooltip = useMemo(() => {
    if (errorCode !== undefined && errorCode > 0) {
      return getWabaErrorMessage(t, errorCode);
    }
    return t("waba_errors.unknown");
  }, [t, errorCode]);

  const renderStatus = useMemo(() => {
    if (status === StatusEnum.Failed || status === StatusEnum.ReSent) {
      const failedIcon = (
        <SvgV2 iconName={"message-failed"} width={16} height={16} className={styles.messageAckFailed} />
      );
      return (
        <>
          {status === StatusEnum.Failed ? (
            <Tooltip delay={300} placement="bottom-right" value={failureTooltip} className={styles.failureTooltip}>
              <span className={styles.failedIconWrap}>{failedIcon}</span>
            </Tooltip>
          ) : (
            failedIcon
          )}
          {!hideResend && status !== StatusEnum.ReSent && (
            <SvgV2
              iconName={"refresh"}
              width={16}
              height={16}
              className={classNames(styles.resendButton, { [styles.sending]: isResending })}
              onClick={() => reSendMessage()}
            />
          )}
        </>
      );
    }
  }, [status, hideResend, isResending, reSendMessage, failureTooltip]);
  return <>{renderStatus}</>;
};
